import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { environment } from "environments/environment";

@Injectable()
export class CountryGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const currentCountry = environment.currentCountry.toLowerCase();
    if (currentCountry === "aus") {
      this.router.navigate(["/horses"]);
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/auth/country-guard.service.ts